module.exports = __webpack_public_path__ + "img/logo-chilecompra.76924409.webp";